define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/action/MoveFromController",
	"csi/table/NewMixin"
], function(array,declare,MoveFromController,NewMixin) {

	return declare([MoveFromController, NewMixin], {
		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			return this.getMovedNodes();
		},

		preProcess: function() {
			// summary: call mixin before continuing
			if (this._newPreProcess()) {
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// summary: call mixin if no action-specific post processing
			return this.inherited(arguments) || this._newPostProcess(); 
		}
	});
});